import { otto } from "@otto-ec/global-resources/nexus";
import { exactagScope } from "../core/utils";
import { exactagData } from "../core/data";
import type { ExactagData } from "../core/core.types";

const log = exactagScope.scope("consent.partner");
const { getConsentsForAllGVs, getIabConsentString, readVendorsConsents } = otto.cmp;

export const consentPartnerMap = {
  16: "xrh", /*                  */
  39: "xad", /*                 */
  40: "xaa", /*                     */
  44: "xta", /*                 */
  70: "xyl", /*                  */
  91: "xcr", /*                */
  559: "xod", /*              */
  755: "xgr", /*                */
  759: "xrj", /*                */
} as const;

export const onetrustConsentPartnerMap = {
  METAR: "xmt", /*           */
  PINRT: "xpn", /*                */
  TKADV: "xtt", /*             */
  SNAPA: "xsc", /*           */
  MSADV: "xms", /*                */
  ADVMK: "xas", /*                          */
  GOANA: "xga", /*                      */
  GOREM: "xgo", /*             */
  CUSDP: "xis", /*                           */
  SPTFY: "xsy", /*                         */
} as const;

/*                                                               */
export const campaignId = "ffaacb82c52393300a9d3b3376091c43";

/**
 *
 *
 *
 *
 *
 *
 */
export function addCampaignId(data = exactagData, campain = campaignId): ExactagData {
  log.debug("Adding campaign id", campain);
  data.campaign = campain;
  return data;
}

/**
 *
 *
 *
 *
 */
export function getPartnerConsents(): ExactagData {
  return { ...exactagData };
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function withConsentResult<T>(result: PromiseSettledResult<T>, errorMessage: string, onValid: (value: T) => void): void {
  if (result.status === "rejected") {
    log.warn(errorMessage, result.reason);
    return;
  }

  return onValid(result.value);
}

/**
 *
 *
 *
 */
export async function updatePartnerConsents(): Promise<ExactagData> {
  /*                         */
  const [iabConsentStringResult, consentsForAllGVsResult, vendorsConsentsResult] = 
    await Promise.allSettled([getIabConsentString(), getConsentsForAllGVs(), readVendorsConsents()]);

  /*                         */
  withConsentResult(iabConsentStringResult, "Could not read IAB consent string", (iabConsentString) => {
    exactagData.xo = iabConsentString;
  });

  /*                */
  withConsentResult(consentsForAllGVsResult, "Could not read Onetrust consents", (allGvs) => {
    Object.entries(allGvs ?? {}).forEach(([onetrustId, consent]) => {
      const exactagId = onetrustConsentPartnerMap[onetrustId as never];
      if (!onetrustId || !exactagId) return;
      exactagData[exactagId] = consent === "1" ? 1 : 0;
    });
  });

  /*              */
  withConsentResult(vendorsConsentsResult, "Could not read vendor consents", (vendorConsents) => {
    vendorConsents.forEach((consent, tcfVendorId) => {
      const exactagId = consentPartnerMap[tcfVendorId as never];
      if (!tcfVendorId || !exactagId) return;
      exactagData[exactagId] = consent ? 1 : 0;
    });
  });

  return getPartnerConsents();
}
